import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import { Message } from 'element-ui'
import store from '@/store'
Vue.use(VueRouter)
// permission 访问所需权限	0游客 1普通用户	2管理员（帖子，评论，审核） 3博主 4审核员
// notPermission 不显示菜单的权限
// record 是否需要记录访问记录 true/false
// auth 是否缓存页面 true/false
// allScreen 是否全屏展示
// icon 图标
const routes = [
	{
		path: '/',
		name:'欢迎页',
		component: () => import('@/views/welcome'),
	},
	{
		path: '/user',
		component: () => import('@/views/user/Index'),
		name: '用户管理',
		meta: {
			permission: [888],
			record: true,
			auth: false,
			icon:"el-icon-user-solid"
		}
	},
	{
		path: '/classify',
		component: () => import('@/views/classify/Index'),
		name: '场地分类',
		meta: {
			permission: [888],
			record: true,
			auth: false,
			icon:"el-icon-s-grid"
		}
	},
	{
		path: '/makeAnAppointment',
		component: () => import('@/views/makeAnAppointment/Index'),
		name: '预约管理',
		meta: {
			permission: [888,2],
			record: true,
			auth: false,
			icon:"el-icon-notebook-2"
		}
	},
	{
		path: '/merchantApplication',
		component: () => import('@/views/merchantApplication/Index'),
		name: '商户申请',
		meta: {
			permission: [888],
			record: true,
			auth: false,
			icon:"el-icon-document"
		}
	},
	{
		path: '/regions',
		component: () => import('@/views/regions/Index'),
		name: '地区管理',
		meta: {
			permission: [888],
			record: true,
			auth: false,
			icon:"el-icon-position"
		}
	},
	{
		path: '/shop',
		component: () => import('@/views/shop/Index'),
		name: '店铺管理',
		meta: {
			permission: [888,2],
			record: true,
			auth: false,
			icon:"el-icon-s-shop"
		}
	},
	{
		path: '/site',
		component: () => import('@/views/site/Index'),
		name: '场地管理',
		meta: {
			permission: [888,2],
			record: true,
			auth: false,
			icon:"el-icon-wind-power"
		}
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/views/404'),
		meta: {
			auth: false,
			allScreen: true
		}
	},
	{
		path: '/403',
		name: '权限不足',
		component: () => import('@/views/403'),
		meta: {
			auth: false,
			allScreen: true
		}
	},
	{
		path: '/login',
		name: '登录/注册',
		component: () => import('@/views/login'),
		meta: {
			auth: false,
			allScreen: true
		}
	},
	{
		path: '*',
		redirect: '/404',
		allScreen: true

	}
]

const router = new VueRouter({
	routes
})

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	if (to.name) {
		document.title = to.name
	}
	
	if(to?.meta?.permission ){
		// 获取用户数据
		let {data} = await store.dispatch('user/getUser')
		if(data.id === 0){
			router.push('/login')
			return next()
		}
		if(!to.meta?.permission?.some(item => item == data.type)){
			Message.error('权限不足');
			console.log('权限不足');
			return next()
		}

	}
	NProgress.done()
	next()
})

export {
	router,
	routes
}